<cf-frontend-sdk-cplace-control-skeleton
  [componentId]="componentId"
  [label]="label"
  [labelPosition]="labelPosition"
  [labelFor]="nativeFormComponentId"
  [validationMessage]="validationMessage"
  [validationSeverity]="validationSeverity"
  [alert]="alert"
  [required]="required"
  [editMode]="($editMode | async)!"
  [submitting]="submitting"
  [submitSuccess]="($submitSuccess | async)!"
  [submitDisabled]="($submitDisabled | async)!"
  [readonly]="readonly"
  [disabled]="disabled"
  (cancelButtonClick)="onCancel()"
>
  <div [class.cf-frontend-sdk-empty-value]="($showEmptyValue | async)!" class="cf-frontend-sdk-input-wrapper">
    <p-inputNumber
      #cplaceSingleNumberControlInput
      [(ngModel)]="value"
      [maxFractionDigits]="maxFractionDigits"
      [minFractionDigits]="minFractionDigits"
      [class.empty-value]="($showEmptyValue | async)!"
      [id]="nativeFormComponentId"
      [name]="label"
      [disabled]="disabled"
      [required]="required"
      [placeholder]="'cf-frontend-sdk.shared.enterValue' | translate"
      [title]="'cf-frontend-sdk.shared.enterValue' | translate"
      [ariaLabel]="label"
      [readonly]="readonly"
      [attr.aria-placeholder]="'cf-frontend-sdk.shared.enterValue' | translate"
      [attr.aria-required]="required"
      [attr.aria-disabled]="disabled"
      [attr.aria-invalid]="validationSeverity !== 'info'"
      [useGrouping]="false"
      autocomplete="off"
    ></p-inputNumber>
  </div>
</cf-frontend-sdk-cplace-control-skeleton>
